import request from "@/utils/request";
import service from "@/utils/axios-v2";
// 获取Terminal列表
export function getTerminalList(parameter) {
  return request({
    url: "/fleet/driver/v2/web/terminal",
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
// 新增Driver
export function driverAdd(data, token = true) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/invite/v3`,
    method: "post",
    data,
    headers: {
      "portal-token": token,
    },
  });
}
// Driver预定义列表
export function getDriverList(data, token = true) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/list`,
    method: "post",
    data,
    headers: {
      "portal-token": token,
    },
  });
}
export function getDriverFuzzyList() {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/search/component`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// 获取 Driver Detail
export function getDriverDetail(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/detail`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
// getCheckELD
export function getCheckELD(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/eld/check`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
// get AssignedLoads List
export function getAssignedLoadsList(data, token = true) {
  return request({
    url: `/fleet/driver/v2/web/load/list`,
    method: "post",
    data,
    headers: {
      "portal-token": token,
    },
  });
}
// editProfile
export function editProfile(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/edit`,
    method: "put",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
// Driver状态修改
export function changeStatus(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/change/status`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
// Driver Map List
export function getDriverMapList(data, token = true) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/map`,
    method: "post",
    data,
    headers: {
      "portal-token": token,
    },
  });
}
// Driver 行为记录List
export function getDriverActivityList(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/activity/list`,
    method: "post",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
// Driver删除
export function invitationDelete(data) {
  return request({
    url: `/fleet/driver/v2/web/delete?driverId=${data.driverId}`,
    method: "Delete",
    headers: {
      "portal-token": true,
    },
  });
}
// Driver 批量删除
export function invitationAllDelete(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/batch/delete`,
    method: "Delete",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
// hos信息编辑
export function hosEdit(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/eld/hos/edit`,
    method: "post",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
// hos信息新增
export function hosAdd(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/eld/hos/add`,
    method: "post",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
// 导出
export function webExport(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/data/export`,
    method: "post",
    data,
    headers: {
      "portal-token": true,
    },
    responseType: "blob",
  });
}
// profile详情
export function getProfile(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/profile`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
export function getTrucks(data) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/truck/list`,
    method: "post",
    data,
    headers: {
      "portal-token": true,
    },
  });
}
export function getOnboarding() {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/company/onboarding_status`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
/**
 * 获取车队司机信息
 * @returns
 */
export function getDriverChatList() {
  return request({
    url: "/fleet/driver/v2/web/chat/list",
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// getData
export function getData() {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/get/enum`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// 验证邮箱是否已经被注册
export function checkUserInfo(params) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/user/tp/info/get",
    method: "GET",
    params: params,
    headers: {
      "portal-token": true,
    },
  });
}
// 获取Driver可邀请数量
export function getAvailable(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver/available`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
// 接收Driver邀请
export function acceptDriverInvitation(parameter) {
  return request({
    url: `/fleet/user/v2/invitation/accept?token=${parameter.token}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// 拒绝Driver邀请
export function rejectDriverInvitation(parameter) {
  return request({
    url: `/fleet/user/v2/invitation/reject?token=${parameter.token}&reason=${parameter.rejectReason}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// 获取Payment Terms列表
export function getPaymentTermsList(params) {
  return request({
    url: `/fleet/settlement_terms/list/${params}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}

// 添加Rate Terms
export function addRateTerms(data) {
  return request({
    url: "/fleet/settlement_terms/add",
    method: "post",
    headers: {
      "portal-token": true,
    },
    data,
  });
}

// 修改Rate Terms
export function updateRateTerms(data) {
  return request({
    url: "/fleet/settlement_terms/update",
    method: "put",
    headers: {
      "portal-token": true,
    },
    data,
  });
}

// 删除Rate Terms
export function deleteRateTerms(id) {
  return request({
    url: `/fleet/settlement_terms/delete/${id}`,
    method: "delete",
    headers: {
      "portal-token": true,
    },
  });
}

// 添加Schedule Terms
export function addScheduleTerms(data) {
  return request({
    url: "/fleet/settlement_schedule_terms/add",
    method: "post",
    headers: {
      "portal-token": true,
    },
    data,
  });
}

// 修改Schedule Terms
export function updateScheduleTerms(data) {
  return request({
    url: "/fleet/settlement_schedule_terms/update",
    method: "put",
    headers: {
      "portal-token": true,
    },
    data,
  });
}

// 删除Schedule Terms
export function deleteScheduleTerms(id) {
  return request({
    url: `/fleet/settlement_schedule_terms/delete/${id}`,
    method: "delete",
    headers: {
      "portal-token": true,
    },
  });
}
// driverInvitationTokenCheck
export function driverInvitationTokenCheck(params) {
  return request({
    url: `/fleet/user/invitation/token/check?token=${params.token}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// delete_invite_record
export function delete_invite_record(data = {}, params) {
  return request({
    url: `/fleet/driver/delete_invite_record?inviteId=${params.inviteId}`,
    method: "delete",
    headers: {
      "portal-token": true,
    },
    data,
  });
}
// driverResendInvite
export function driverResendInvite(params) {
  return request({
    url: `/fleet/driver/resend_invite?inviteId=${params.inviteId}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// driverInviteReject
export function driverInviteReject(params) {
  return request({
    url: `/fleet/driver/invite/reject/v2?token=${params.token}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// Driver Team: List
export function getDriverTeamList(data, token = true) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver-team/page`,
    method: "get",
    params: data,
    headers: {
      "portal-token": token,
    },
  });
}
export function getDriverTeamFuzzyList(token = true) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver-team/search/component`,
    method: "get",
    headers: {
      "portal-token": token,
    },
  });
}
// Driver Team: Get
export function getDriverTeamDetail(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver-team/${parameter.teamId}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// Driver Team: Get
export function getPaymentTermListByDriverId(parameter) {
  return request({
    url: `/fleet/driver-team/settlement/${parameter.driverId}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
// Driver Team: Add/Update
export function updateDriverTeam(data, token = true) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver-team/update`,
    method: "post",
    data,
    headers: {
      "portal-token": token,
    },
  });
}
// Driver Team: active/inactive
export function activeOrInactiveDriverTeam(data, token = true) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver-team/update/status`,
    method: "post",
    data,
    headers: {
      "portal-token": token,
    },
  });
}
// Driver Team: Delete
export function deleteDriverTeam(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver-team/${parameter.teamId}`,
    method: "delete",
    headers: {
      "portal-token": true,
    },
  });
}
// Driver Team: Delete
export function getDriverData(parameter) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/driver-team/driver/list`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}

//
export function driverListForAssign(driverName, fleetCompanyId) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/V3/list/assign-load?driverName=${driverName}${fleetCompanyId ? `&fleetCompanyId=${fleetCompanyId}` : ''}`,
    method: "get",
    headers: {
      "portal-token": true,
    },
  });
}
export function assignToTeam(teamId, data, isReassign) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: `/zuul/load/V3/assign/load/to/team?loadId=${data[0]}`,
    method: "post",
    headers: {
      "portal-token": true,
    },
    isNotPrompt: true,
    data: {
      "loadsId": data,
      "teamId": teamId,
      "loadAssignType" : isReassign ? 'reAssign' : 'assign'
    }
  });
}

export function reAssignToTeam(teamId, data) {
  return service({
    url: `/fleet/dispatch/reassign-to-team`,
    method: "post",
    headers: {
      "portal-token": true,
    },
    isNotPrompt: true,
    data: {
      "loadsId": data,
      "teamId": teamId
    }
  });
}
export const getCarrieListForDispatcher = (token = true) => {
  return service("/carrier/list/for/dispatcher", {
    method: "get",
    baseURL: process.env.VUE_APP_DSP_URL,
    headers: {
      "Content-Type": "application/json",
      "portal-token": token,
    },
  });
};
// resendInvite
export function resendInvite(params) {
  return request({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: "/zuul/driver/resend-invite/V2",
    method: "GET",
    params: params,
    headers: {
      "portal-token": true,
    },
  });
}

export function downloadTerminal(params) {
  return service({
    baseURL: process.env.VUE_APP_TP_URL,
    url: "/fleet/user/terminal/data/export",
    method: "GET",
    params: params,
    headers: {
      "portal-token": true,
    },
  });
}